import { ILanguage } from '@aqx/i18n';

import { TAppLanguageISOCountryCode } from './types';

export const LANGUAGES_REQUIRING_LARGER_HEADER: TAppLanguageISOCountryCode[] = ['id_ID', 'ja_JP', 'th_TH'];

export const LANGUAGES_REQUIRING_WIDER_CONFIDENCE: TAppLanguageISOCountryCode[] = ['id_ID', 'ms_MY', 'vi_VN'];

export const APP_LANGUAGES_MAP: Record<TAppLanguageISOCountryCode, ILanguage<TAppLanguageISOCountryCode>> = {
  en_GB: {
    value: 'en_GB',
    label: 'English'
  },
  zh_CN: {
    value: 'zh_CN',
    label: '简体中文'
  },
  zh_TW: {
    value: 'zh_TW',
    label: '繁体中文'
  },
  th_TH: {
    value: 'th_TH',
    label: 'ภาษาไทย'
  },
  vi_VN: {
    value: 'vi_VN',
    label: 'Tiếng Việt'
  },
  ms_MY: {
    value: 'ms_MY',
    label: 'Bahasa Melayu'
  },
  id_ID: {
    value: 'id_ID',
    label: 'Bahasa Indo'
  },
  ja_JP: {
    value: 'ja_JP',
    label: '日本語'
  },
  ko_KR: {
    value: 'ko_KR',
    label: '한국어'
  },
  ar_AE: {
    value: 'ar_AE',
    label: 'Arabic'
  },
  es_ES: {
    value: 'es_ES',
    label: 'Español'
  },
  pt_BR: {
    value: 'pt_BR',
    label: 'Português'
  }
};

export const APP_LANGUAGES: ILanguage<TAppLanguageISOCountryCode>[] = Object.values(APP_LANGUAGES_MAP);

export enum ELanguageQueryString {
  AR = 'ar',
  EN = 'en',
  ES = 'es',
  ID = 'id',
  JA = 'ja',
  JP = 'jp',
  KO = 'ko',
  MS = 'ms',
  PT = 'pt',
  TH = 'th',
  VI = 'vi',
  VN = 'vn',
  ZH = 'zh',
  ZH_HANS = 'zh-hans',
  ZH_HANT = 'zh-hant'
}

export const mapLangQueryStringToTLang: Record<ELanguageQueryString, TAppLanguageISOCountryCode> = {
  [ELanguageQueryString.AR]: 'ar_AE',
  [ELanguageQueryString.EN]: 'en_GB',
  [ELanguageQueryString.ES]: 'es_ES',
  [ELanguageQueryString.ID]: 'id_ID',
  [ELanguageQueryString.JA]: 'ja_JP',
  [ELanguageQueryString.JP]: 'ja_JP',
  [ELanguageQueryString.KO]: 'ko_KR',
  [ELanguageQueryString.MS]: 'ms_MY',
  [ELanguageQueryString.PT]: 'pt_BR',
  [ELanguageQueryString.TH]: 'th_TH',
  [ELanguageQueryString.VI]: 'vi_VN',
  [ELanguageQueryString.VN]: 'vi_VN',
  [ELanguageQueryString.ZH]: 'zh_CN',
  [ELanguageQueryString.ZH_HANS]: 'zh_CN',
  [ELanguageQueryString.ZH_HANT]: 'zh_TW'
};

export const HANTEC_LANGUAGES_CODE: TAppLanguageISOCountryCode[] = [
  'en_GB',
  'es_ES',
  'ja_JP',
  'ko_KR',
  'pt_BR',
  'zh_CN',
  'zh_TW',
  'th_TH'
];
